$(function () {
  $("nav div").on("click", function () {
    $(".triangle-container").remove();
    show_content($(this).index());
  });

  show_content(0);

  function show_content(index) {
    // Make the content visible
    $(".tabs .content.visible").removeClass("visible");
    $(".tabs .content:nth-of-type(" + (index + 1) + ")").addClass("visible");

    // Set the tab to selected
    $("nav div.selected").removeClass("selected");
    $("nav div:nth-of-type(" + (index + 1) + ")").addClass("selected");
  }
});

const numberToPrice = (num) => {
  if (num === 0) return 0;

  num = num.toString();

  let dollars = num.substring(0, num.length - 2);
  let cents = num.substr(-2);
  let price = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + cents;

  return price;
};

const showMobileMenuChilds = (selector) => {
  const menu = document.querySelector(selector);
  menu.classList.toggle("active-menu");
};

jQuery(function ($) {
  $("nav#my-menu").mmenu({
    slidingSubmenus: false,
  });

  $("nav#menu-right").mmenu({
    slidingSubmenus: false,
    extensions: ["position-right", "pagedim-black"],
  });

  /** Button Search **/
  var _event_search = false;
  $("a#button-search").click(function (e) {
    e.preventDefault();
    var objSearch = $(".site-header-main .site-search");
    if (!objSearch.is(":visible")) {
      objSearch.fadeIn(300, function () {
        $(this).find(".search-field").focus();
        _event_search = true;
      });
    } else {
      objSearch.fadeOut(300);
      _event_search = false;
    }
  });
  $("body").click(function (e) {
    var objSearch = $(".site-header-main .site-search");
    if (
      e.target.className != "search-field" &&
      objSearch.is(":visible") &&
      _event_search
    ) {
      objSearch.fadeOut(300);
      _event_search = false;
    }
  });
  $(window).resize(function () {
    $(".site-header-main .site-search").css("display", "none");
    _event_search = false;
  });
});

// TABS
$.fn.responsiveTabs = function () {
  return this.each(function () {
    var el = $(this),
      tabs = el.find("dt"),
      content = el.find("dd"),
      placeholder = $(
        '<div class="responsive-tabs-placeholder"></div>'
      ).insertAfter(el);

    tabs.on("click", function () {
      var tab = $(this);

      tabs.not(tab).removeClass("active");
      tab.addClass("active");

      placeholder.html(tab.next().html());
    });

    tabs.filter(":first").trigger("click");
  });
};

$(".responsive-tabs").responsiveTabs();
